export default "__VITE_ASSET__zWIrTk$d__"